
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.093 1H3.146A2.178 2.178 0 001.12 3.027V36.72A2.234 2.234 0 003.146 39h18.24V24.307H16.32V18.48h5.066v-4.053a6.985 6.985 0 016.33-7.583 6.905 6.905 0 011.017-.017c2.026 0 3.8.253 4.306.253v5.067H30c-2.28 0-2.786 1.013-2.786 2.786v3.547h5.573l-.76 5.827h-4.814V39h9.626a2 2 0 002.027-1.971v-34a1.8 1.8 0 00-1.551-2.012A1.645 1.645 0 0037.093 1z"}})])
          )
        }
      }
    